export default __webpack_public_path__ + "static/029-0a23a6540a23f8c3d590e0042644477f.png";